import { DatePipe } from "@angular/common";
import {
	AfterContentChecked,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from "@angular/core";
import {
	FormBuilder,
	FormControl,
	FormGroup,
	Validators,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Observable, forkJoin, map, startWith } from "rxjs";
import { NotificacionCese } from "src/app/_core/models/centros/NotificacionCese.model";
import { SociedadViewModel } from "src/app/_core/models/centros/SociedadViewModel";
import { ActividadViewModel } from "src/app/_core/models/centros/actividad.model";
import { CebeViewModel } from "src/app/_core/models/centros/cebe.model";
import { EmpleadoViewModel } from "src/app/_core/models/centros/empleado.model";
import { PaisViewModel } from "src/app/_core/models/centros/pais.model";
import { TipoProyectoViewModel } from "src/app/_core/models/centros/tipo-proyecto.model";
import { ZonaViewModel } from "src/app/_core/models/centros/zona.model";
import { AuthService } from "src/app/_core/providers/auth.service";
import { CebesService } from "src/app/_core/providers/cebes.service";
import { MasterService } from "src/app/_core/providers/master.service";
import { NotificationService } from "src/app/_core/providers/notification.service";
import { UserProfileStore } from "src/app/_core/stores/user-profile.store";
import { CebePageComponent } from "../../../pages/cebe/cebe.page";
import { ConfirmationService } from "primeng/api";
@Component({
	selector: "app-cebe-details-card",
	templateUrl: "./cebe-details-card.component.html",
	styleUrls: ["./cebe-details-card.component.scss"],
	providers: [DatePipe, ConfirmationService],
})
export class CebeDetailsCardComponent implements OnInit, AfterContentChecked {
	// Parameters
	@Input() cebe!: CebeViewModel;
	@ViewChild("nombreInput", { static: true }) nombreInput: ElementRef;
	@Input() parent: CebePageComponent;
	@Input() validatedCebeDetailsForm: boolean;
	@Output() ofertaToggleEvent = new EventEmitter<boolean>();
	@Output() contratoToggleEvent = new EventEmitter<boolean>();
	@Output() detailFormComplete = new EventEmitter<boolean>();
	@Output() centroToggleEvent = new EventEmitter<boolean>();

	public employees: EmpleadoViewModel[] = [];
	employeesfilter: Observable<EmpleadoViewModel[]>;
	public photo: any = "/assets/images/user.png";
	public activities: ActividadViewModel[] = [];
	public countries: PaisViewModel[] = [];
	public zones: ZonaViewModel[] = [];
	public allprojectTypes: TipoProyectoViewModel[] = [];
	public projectTypes: TipoProyectoViewModel[] = [];
	public sociedad: SociedadViewModel;
	employeeControl: FormControl = new FormControl("", Validators.required);
	supervisionControl: FormControl = new FormControl("");
	myForm: FormGroup;
	countControls: number = 0;
	countFilled: number = 0;
	notificacionCese: NotificacionCese;
	notificacionAlta: NotificacionCese;
	imagenPreview: string | ArrayBuffer | null = null;
	imagenFile: File | null = null;

	constructor(
		private readonly userProfileStore: UserProfileStore,
		private readonly _masterService: MasterService,
		private readonly _authService: AuthService,
		private readonly _cebesService: CebesService,
		private readonly fb: FormBuilder,
		public _translateService: TranslateService,
		private readonly _notificationService: NotificationService,
		private readonly datePipe: DatePipe,
		private readonly confirmationService: ConfirmationService,
	) {}

	// Events
	ngOnInit(): void {
		this._loadData();
		this._loadForm();
	}

	private _loadData(): void {
		forkJoin([
			this._masterService.getEmpleados(),
			this._masterService.getActividades(),
			this._masterService.getPaises(),
			this._masterService.getZonasUnidadesOrganicas(
				this.cebe.sociedadID,
				this.cebe.responsableID,
			),
			this._masterService.getTiposProyecto(),
			this._masterService.getSociedadById(this.cebe.sociedadID),
		]).subscribe(([s1, s2, s3, s4, s5, s6]) => {
			this.employees = s1;
			this.activities = s2;
			this.countries = s3;
			this.zones = s4;
			this.allprojectTypes = s5;
			this.sociedad = s6;
			this.projectTypes = this.allprojectTypes.filter(
				(f) => f.actividadID == this.cebe.actividadID,
			);
			const empleado: EmpleadoViewModel = this.employees.find(
				(f) => f.id == this.cebe.responsableID,
			);
			this.employeeControl.setValue(empleado);
			this.getPhoto(empleado?.email);
		});
		this.getNotificacionAlta();
		this.getNotificacionCese();
		this.imagenPreview = this.cebe?.imageDataB64;
	}

	private _loadForm() {
		this.myForm = this.fb.group({
			id: [this.cebe?.id],
			codigo: [this.cebe?.codigo],
			actividadID: [this.cebe?.actividadID],
			responsable: this.employeeControl,
			descripcion: [this.cebe?.descripcion, [Validators.required]],
			paisID: [this.cebe?.paisID],
			tipoProyectoID: [
				this.cebe?.tipoProyectoID == 0
					? null
					: this.cebe?.tipoProyectoID,
				[Validators.required],
			],
			sostenibilidad: [this.cebe?.sostenibilidad],
			isContrato: [this.cebe?.isContrato],
			oferta: [this.cebe?.oferta],
			uteConsolidacionFinanciera: [this.cebe?.uteConsolidacionFinanciera],
			porcentajeConsolidacion: [this.cebe?.porcentajeConsolidacion],
			zonaID: [this.cebe?.zonaID],
			sociedad: [this.sociedad?.descripcion],
			centro: [this.cebe?.centro],
			imageDataB64: [this.cebe?.imageDataB64],
		});

		this.employeesfilter = this.employeeControl.valueChanges.pipe(
			startWith(""),
			map((value) => (typeof value === "string" ? value : value?.nombre)),
			map((nombre) =>
				nombre ? this._filter(nombre) : this.employees.slice(),
			),
		);

		const actividadIDValue = this.myForm.get("actividadID")?.value;
		const tipoProyectoIDValue = this.myForm.get("tipoProyectoID")?.value;

		this._cebesService.setActividadIDValue(actividadIDValue);
		this._cebesService.setTipoProyectoIDValue(tipoProyectoIDValue);

		this.myForm.get("actividadID")?.valueChanges.subscribe((s) => {
			this.projectTypes = this.allprojectTypes.filter(
				(f) => f.actividadID == s,
			);
			if (this.projectTypes && this.projectTypes.length > 0) {
				const firstOptionValue = this.projectTypes[0].id;
				this.myForm.get("tipoProyectoID")?.setValue(firstOptionValue);
			}
			this._cebesService.setActividadIDValue(s);
			this._cebesService.triggerCebeActividadValueChanged();
		});

		this.myForm.get("tipoProyectoID")?.valueChanges.subscribe((value) => {
			this._cebesService.setTipoProyectoIDValue(value);
			this._cebesService.triggerCebeTipoProyectoValueChanged();
		});

		this.myForm.valueChanges.subscribe(() => {
			this.getFormStatus();
		});
	}

	ngAfterContentChecked(): void {
		this.getFormStatus();
	}

	confirm1(event: Event, x: boolean) {
		this.confirmationService.confirm({
			target: event.target as EventTarget,
			message: x
				? this._translateService.instant(
						"messages.confirmDialogMessageAlta",
					)
				: this._translateService.instant(
						"messages.confirmDialogMessageCese",
					),

			header: this._translateService.instant(
				"messages.confirmDialogHeader",
			),
			icon: "pi pi-exclamation-triangle",
			acceptIcon: "pi pi-check", // Ícono para aceptar
			rejectIcon: "pi pi-times", // Ícono para rechazar
			acceptLabel: this._translateService.instant("boolean.true"),
			rejectLabel: this._translateService.instant("boolean.false"),
			rejectButtonStyleClass: "p-button-text",
			accept: () => {
				if (x) {
					this.NotifcarAlta();
				} else {
					this.NotifcarCese();
				}
			},
			reject: () => {
				null;
			},
		});
	}

	getFormStatus() {
		this.countControls = 0;
		this.countFilled = 0;

		Object.keys(this.myForm.controls).forEach((controlName) => {
			if (
				controlName !== "uteConsolidacionFinanciera" &&
				controlName !== "porcentajeConsolidacion" &&
				controlName !== "sociedad" &&
				controlName !== "responsable" &&
				controlName !== "id"
			) {
				const control = this.myForm.get(controlName);
				const controlElement = document.querySelector(
					`[formControlName="${controlName}"]`,
				);

				if (controlElement) {
					const hasHiddenClass =
						controlElement.parentElement.classList.contains(
							"hidden",
						);

					if (!hasHiddenClass) {
						this.countControls++;

						if (control.value !== null && control.value !== "") {
							this.countFilled++;
						}
					}
				}
			}
		});

		if (this.countFilled !== 0) {
			this.detailFormComplete.emit(
				this.countControls == this.countFilled,
			);
		}
	}

	sendOfertaToggleEvent(value: boolean) {
		this.ofertaToggleEvent.emit(value);
		this.myForm.get("oferta")?.setValue(value);
		this.onSubmit();
	}

	sendContratoToggleEvent(value: boolean) {
		this.contratoToggleEvent.emit(value);
		this.myForm.get("contrato")?.setValue(value);
		this.onSubmit();
	}

	sendCentroToggleEvent(value: boolean) {
		this.centroToggleEvent.emit(value);
		this.myForm.get("centro")?.setValue(value);
		this.onSubmit();
	}

	private _filter(nombre: string): EmpleadoViewModel[] {
		const filterValue = nombre.toLowerCase();
		return this.employees.filter((option) =>
			option.nombre.toLowerCase().includes(filterValue),
		);
	}

	private markFormGroupTouched(formGroup: FormGroup) {
		Object.values(formGroup.controls).forEach((control) => {
			control.markAsTouched();

			if (control instanceof FormGroup) {
				this.markFormGroupTouched(control);
			}
		});
	}

	onSubmit(): boolean {
		if (this.myForm.valid) {
			const formData = this.myForm.value as CebeViewModel;
			formData.responsableID = this.employeeControl.value.id;
			// formData.zonaID = this.cebe.zonaID;

			this._cebesService.updateCebe(formData).subscribe(() => {
				this.parent.loadCebeInit();
			});
			this._notificationService.showSuccess(
				this._translateService.instant("messages.savedSuccessfully"),
				null,
			);
			return true;
		} else {
			this.markFormGroupTouched(this.myForm);
			this._notificationService.showError(
				`${this._translateService.instant(
					"cebe.generalData.title",
				)} - ${this._translateService.instant(
					"messages.validationErrors",
				)}`,
			);

			return false;
		}
	}

	triggerFormSubmission(): boolean {
		return this.onSubmit();
	}

	displayFn(empleado?: EmpleadoViewModel): string | undefined {
		return empleado ? empleado.nombre : undefined;
	}

	onOptionSelected(event) {
		const empleado = event.option.value;
		this.nombreInput.nativeElement.value = empleado.nombre;
		this.getPhoto(empleado.email);
		this._masterService
			.getZonasUnidadesOrganicas(this.cebe.sociedadID, empleado.id)
			.subscribe((s) => {
				this.zones = s;
			});
	}

	public getUserLocale(): string {
		let locale: string = "en-US";
		const userProfile = this.userProfileStore.getUserProfile();
		if (userProfile && userProfile.preferredLang) {
			if (userProfile.preferredLang == "es") {
				locale = "es-ES";
			} else if (userProfile.preferredLang == "pl") {
				locale = "pl-PL";
			}
		}
		return locale;
	}

	public getPhoto(email: string) {
		this._authService.getUserPhoto(email).subscribe(
			(photoResult) => {
				const reader = new FileReader();
				reader.addEventListener(
					"load",
					() => {
						if (reader && reader.result) {
							this.photo = reader.result;
						} else {
							this.photo = "/assets/images/user.png";
						}
					},
					false,
				);

				if (photoResult) {
					reader.readAsDataURL(photoResult);
				}
			},
			(error) => {
				this.photo = "/assets/images/user.png";
			},
		);
	}

	formatLabel(value: number) {
		return `${value}%`;
	}

	showHideTipoProyectoTooltip() {
		if (this.cebe.actividadID == 1) {
			return true;
		} else {
			return false;
		}
	}
	NotifcarCese() {
		this._cebesService.NotificarCese(this.cebe.id).subscribe((s) => {
			this.getNotificacionCese();
			this._notificationService.showSuccess(
				this._translateService.instant("messages.savedSuccessfully"),
				null,
			);
			this.parent.ngOnInit();
		});
	}

	NotifcarAlta() {
		this._cebesService.NotificarAlta(this.cebe.id).subscribe((s) => {
			this.getNotificacionAlta();
			this._notificationService.showSuccess(
				this._translateService.instant("messages.savedSuccessfully"),
				null,
			);
			this.parent.ngOnInit();
		});
	}

	getNotificacionCese() {
		this._cebesService.getNotificacionCese(this.cebe.id).subscribe((s) => {
			this.notificacionCese = s;
		});
	}

	getNotificacionAlta() {
		this._cebesService.getNotificacionAlta(this.cebe.id).subscribe((s) => {
			this.notificacionAlta = s;
		});
	}

	getMensajeNotificacionCese() {
		if (this.notificacionCese) {
			let texto: String = "";
			texto += this._translateService.instant(
				"cebe.generalData.NotificacionCese1",
			);
			if (this.employees && this.employees.length > 0) {
				const empleado = this.employees.find(
					(f) => f.id == this.notificacionCese.empleadoId,
				);
				if (empleado) {
					texto += `${empleado.nombre} `;
				} else {
					texto += `Empleado ID: ${this.notificacionCese.empleadoId} `;
				}
			} else {
				texto += `Empleado ID: ${this.notificacionCese.empleadoId} `;
			}
			texto += this._translateService.instant(
				"cebe.generalData.NotificacionCese2",
			);
			const date = new Date(this.notificacionCese.fechaDeNotificacion);
			texto += this.datePipe.transform(date, "dd/MM/yyyy");
			return texto;
		} else {
			return "";
		}
	}

	getMensajeNotificacionAlta() {
		if (this.notificacionAlta) {
			let texto: String = "";
			texto += this._translateService.instant(
				"cebe.generalData.NotificacionAlta1",
			);
			if (this.employees && this.employees.length > 0) {
				const empleado = this.employees.find(
					(f) => f.id == this.notificacionAlta.empleadoId,
				);
				if (empleado) {
					texto += `${empleado.nombre} `;
				} else {
					texto += `Empleado ID: ${this.notificacionAlta.empleadoId} `;
				}
			} else {
				texto += `Empleado ID: ${this.notificacionAlta.empleadoId} `;
			}
			texto += this._translateService.instant(
				"cebe.generalData.NotificacionAlta2",
			);
			const date = new Date(this.notificacionAlta.fechaDeNotificacion);
			texto += this.datePipe.transform(date, "dd/MM/yyyy");
			return texto;
		} else {
			return "";
		}
	}

	onFileChange(event: Event) {
		const input = event.target as HTMLInputElement;
		const file = input.files && input.files[0];
		const fileSizeKb = file.size / 1024;

		if (
			file &&
			(file.type === "image/jpeg" || file.type === "image/png") &&
			fileSizeKb <= 1000
		) {
			this.imagenFile = file;

			const reader = new FileReader();
			reader.onload = () => {
				const base64Image = reader.result as string;
				this.myForm.patchValue({ imageDataB64: base64Image });
				this.myForm.get("imageDataB64")?.updateValueAndValidity();
				this.imagenPreview = base64Image;
			};

			reader.readAsDataURL(file);
		} else {
			this.myForm.patchValue({ imageDataB64: null });
			this.imagenFile = null;
			this.imagenPreview = null;
			input.value = "";
			if (fileSizeKb > 1000) {
				alert(
					this._translateService.instant(
						"messages.imageRequiredType",
					),
				);
			}
		}
	}
}
